import { FC } from "react";

import { OutlookColored } from "@livechat/design-system-icons";
import { Icon, Link, SpacingToken, Text } from "@livechat/design-system-react-components";

import { AccordionItem } from "components/accordion-item/AccordionItem";
import Block from "components/layout/Block";
import { HelpCenter } from "constants/help-center";
import { IProviderItemProps } from "interfaces/providerItem";
import { withVar } from "themes/helpers";

import { ForwardingAddressCopy } from "./ForwardingAddressCopy";
import { LiWithMargin, StepsList } from "./styles";
import { onHelpCenterLinkClick } from "./trackProviderEngagement";

export const MSOutlookProvider: FC<IProviderItemProps> = ({
  opened,
  onHeaderClick,
  inboxAddress,
  handleMailboxCopying,
}) => (
  <AccordionItem
    opened={opened}
    onHeaderClick={onHeaderClick}
    title="Microsoft Outlook"
    icon={<Icon size="large" source={OutlookColored} />}
    className="provider-accordion-item"
  >
    <StepsList>
      <LiWithMargin>
        Access Microsoft Outlook&apos;s{" "}
        <Link bold target="_blank" href="https://outlook.live.com/mail/0/options/mail/forwarding">
          forwarding settings
        </Link>
        .
      </LiWithMargin>
      <LiWithMargin>Enable forwarding.</LiWithMargin>
      <LiWithMargin>
        Enter HelpDesk&apos;s forwarding address.
        <ForwardingAddressCopy inboxAddress={inboxAddress} handleMailboxCopying={handleMailboxCopying} />
      </LiWithMargin>
      <LiWithMargin>
        Select <b>&quot;Close&quot;</b> to save changes.
      </LiWithMargin>
      <LiWithMargin>
        Optional: <b>Send a test message</b> to your own inbox or wait for the first email from a recipient.
      </LiWithMargin>
    </StepsList>
    <Block marginTop={withVar(SpacingToken.Spacing4)}>
      <Text>
        Learn more about{" "}
        <Link
          bold={false}
          target="_blank"
          href={HelpCenter.MICROSOFT_OUTLOOK_EMAIL_FORWARDING}
          onClick={onHelpCenterLinkClick}
        >
          Microsoft Outlook email forwarding
        </Link>
        .
      </Text>
    </Block>
  </AccordionItem>
);
